module.exports = __webpack_public_path__ + "static/media/badge.aaa3ade1.svg";